import $ from "../../libs/jquery-3.3.1.min.js"
import {BaseGameCaChauffe} from "../base/BaseGameCaChauffe";
import {AudioPlaylist} from '../base/AudioPlaylist.js';
import FontFaceObserver from '../../libs/fontfaceobserver.js';
import {gsap} from "../../libs/gsap/all.js";

import {Howl} from "howler";
import {IdleScreen} from "./minigames/IdleScreen";
import {GameA} from "./minigames/GameA";
import {GameB} from "./minigames/GameB";
import {GameC} from "./minigames/GameC";

const ONE_HOUR = 60 * 60 * 1000;
const REFRESH_APP_DELAY = ONE_HOUR * 8;

// Constructor
export class ActiviteHumaine extends BaseGameCaChauffe {

  constructor() {
    super(`data/activite-humaine.json`);

    // Object class
    this.playlist = new AudioPlaylist();

    // Animation timeline
    this.currentTimeline = null;

    this.games = [];

    // Wait for all
    Promise.all([
      this.loadSettings(),
      this.loadData(),
      this.loadData("data/cachauffe-global.json")
    ]).then(() => {
      // Preload audio files
      return this.preloadAudio();
    }).then(() => {
      // Preload fonts
      return this.preloadFont();
    }).then(() => {
      // Ini nunjucks
      return this.initNunjucks();
    }).then(() => {
      // Replace strings {{ }}
      return this.renderNunjucks();
    }).then(() => {
      // Init pixi games
      return this.initMinigame();
    }).then(() => {
      // Convert IMG to inline SVG
      return window.convertSVGToInline();
    }).then(() => {
      // Real game init
      return this.initGame();
    }).catch((error) => {
      console.error("error", error)
      $("#main").append("<div id='error'>Error: " + error.message + "</div>")
    });
  }

  preloadFont() {
    const fonts = [
      new FontFaceObserver("Halyard Display", {weight: 300}),
      new FontFaceObserver("Halyard Display", {weight: 400}),
      new FontFaceObserver("Halyard Display", {weight: 500}),
      new FontFaceObserver("Halyard Display", {weight: 600}),
      new FontFaceObserver("Halyard Display", {weight: 700}),
      // TODO: Add missing fonts? Remove unnecessary fonts
    ];

    // Load each observer, then return promise
    let observers = [];
    for (let i = 0; i < fonts.length; i++) {
      observers.push(fonts[i].load());
    }

    return Promise.all(observers);
  }

  initMinigame() {

    return new Promise((resolve, reject) => {

      this.games.push(new IdleScreen(this.data.content.idleScreen.game_data));
      this.games.push(new GameA(this.data.content.gameA.game_data));
      this.games.push(new GameB(this.data.content.gameB.game_data));
      this.games.push(new GameC(this.data.content.gameC.game_data));

      const initPromises = [];
      for (let i = 0; i < this.games.length; i++) {
        const game = this.games[i];
        const className = game.constructor.name;
        const screenEl = $(".screen[data-game-type='" + className + "']");
        const initPromise = game.init($(screenEl).find(".pixi-app")[0])
          .then(() => game.assetLoader())
          .then(() => game.buildStage())
          .then(() => {
            game.canvas.addEventListener("webglcontextlost", (event) => {
              this.restartApp();
            }, false);
            game.on("complete", () => {
              console.log("Game completed!");
              this.switchGame(0);
            });
          })

        initPromises.push(initPromise);
      }

      // Resolve all init Promises before resolving main Promise
      Promise.all(initPromises).then(() => resolve()).catch(reject)
    });

  }

  // To be overridden in child games
  initGame() {
    console.log("init game")
    // TODO: Complete initialization of game
    this.initScreenSaver();
    // this.goToScreen(1);
    this.switchGame(0);

    // TODO: For debugging
    // setTimeout(() => {
    //   this.switchGame(2);
    // }, 500);
  }

  // To be overridden in child games
  initScreen(screenId) {

    console.log("init screen from AH", screenId);

    // Super constructor
    if (super.initScreen(screenId) === false) {
      return false;
    }

    for (let i = 0; i < this.games.length; i++) {
      this.games[i].deactivate();
    }

    this.games[screenId - 1].activate();

    const $screenElement = $("#screen-" + screenId);
    const screenName = $screenElement.data("name");

    console.log('gotoScreen', screenId, screenName);
  }

  // TODO: Function to pause/resume rendering of canvas if that game is displayed or not
  switchGame(index) {
    console.log("will go to game", index);

    this.games[index].reset();

    this.goToScreen(index + 1, () => {
      console.log("calling begin", this.games, index);
      this.games[index].begin();

      // Full app reload after 8 hours
      if (index === 0 && inElectron()) {
        if (Date.now() - this.upSince > REFRESH_APP_DELAY) window.refreshApp();
        else console.log("Will request refresh in " + (REFRESH_APP_DELAY - (Date.now() - this.upSince)) / (60 * 1000) + " minutes.")
      }

    });
  }


  // goToScreen(screenId, callback, skipLockScreenCheck = false, inBetweenTransitionsCallback) {
  //
  //   // Stop on lock
  //   if (!skipLockScreenCheck && this.lockScreen) {
  //     console.log("prevent locked screen animation")
  //     return false;
  //   }
  //
  //   // Prevent requesting a re-animation of the same screen
  //   // while being animated to, or currently on a screen.
  //   if (this.targetScreen === screenId) {
  //     console.log("prevent same screen animation")
  //     return;
  //   }
  //
  //   this.targetScreen = screenId;
  //   this.lockScreen = true;
  //   $("body").css("pointer-events", "none");
  //
  //   if (this.screenTimeline) {
  //     this.screenTimeline.kill();
  //     this.screenTimeline = null;
  //   }
  //
  //   const currentScreen = $(".screen.current");
  //   const nextScreen = $(`#screen-${screenId}`);
  //   this.screenTimeline = gsap.timeline();
  //
  //   if (currentScreen.length > 1) {
  //     console.warn("There are multiple screens marked as `current`, which is not a good thing and may create multiple callbacks.")
  //   }
  //
  //   //Animate in/out + callback
  //   if (currentScreen.length > 0 && nextScreen.length > 0) {
  //
  //     // If there is a current screen and a new screen, fade out current and fade in new, then callback
  //     currentScreen.removeClass("current");
  //
  //     this.screenTimeline.to(currentScreen, {
  //       alpha: 0,
  //       duration: 0.4,
  //     })
  //
  //     this.screenTimeline.add(() => {
  //       $("body").removeClass("current-screen-" + this.currentScreen).addClass("current-screen-" + screenId);
  //       $(".screen").addClass("hidden");
  //       this.initScreen(screenId);
  //
  //       if (typeof inBetweenTransitionsCallback == "function") {
  //         inBetweenTransitionsCallback();
  //       }
  //
  //       nextScreen.removeClass("hidden");
  //     });
  //
  //     this.screenTimeline.to(nextScreen, {
  //       alpha: 1,
  //       duration: 0.4,
  //     })
  //
  //     this.screenTimeline.add(() => {
  //       this.currentScreen = screenId;
  //       this.lockScreen = false;
  //       // this.targetScreen = null;
  //       $("body").css("pointer-events", "");
  //       $("#screen-" + screenId).addClass("current");
  //       if (typeof callback == "function") {
  //         callback();
  //       }
  //     });
  //
  //   } else if (currentScreen.length === 0 && nextScreen.length > 0) {
  //     $("body").removeClass("current-screen-" + this.currentScreen).addClass("current-screen-" + screenId);
  //     $(".screen").addClass("hidden");
  //     this.initScreen(screenId);
  //
  //     if (typeof inBetweenTransitionsCallback == "function") {
  //       inBetweenTransitionsCallback();
  //     }
  //
  //     // If there is no current screen and a new screen,fade in new, then callback
  //     nextScreen.removeClass("hidden")
  //
  //     this.screenTimeline.to(nextScreen, {
  //       alpha: 1,
  //       duration: 0.4,
  //     });
  //
  //     this.screenTimeline.add(() => {
  //       this.currentScreen = screenId;
  //       this.lockScreen = false;
  //       // this.targetScreen = null;
  //       $("body").css("pointer-events", "");
  //       $("#screen-" + screenId).addClass("current");
  //       if (typeof callback == "function") {
  //         callback();
  //       }
  //     });
  //
  //   } else if (screenId === 0 || currentScreen.length > 0 && nextScreen.length == 0) {
  //
  //     // If there is a current screen and no new screen, fade out current then callback
  //     currentScreen.removeClass("current")
  //
  //     this.screenTimeline.to(currentScreen, {
  //       alpha: 0,
  //       duration: 0.4
  //     });
  //
  //     this.screenTimeline.add(() => {
  //       $("body").removeClass("current-screen-" + this.currentScreen).addClass("current-screen-" + screenId);
  //       $(".screen").addClass("hidden");
  //
  //       this.initScreen(screenId);
  //
  //       if (typeof inBetweenTransitionsCallback == "function") {
  //         inBetweenTransitionsCallback();
  //       }
  //
  //       this.currentScreen = screenId;
  //       this.lockScreen = false;
  //       // this.targetScreen = null;
  //       $("body").css("pointer-events", "");
  //       if (typeof callback == "function") {
  //         callback();
  //       }
  //     })
  //   }
  //
  //   return true;
  // }

  /**
   * Reset function, used to go back clean version of the game
   * @param screenId
   * @returns {boolean}
   */
  reset(screenId) {
    // TODO: Reset things here

    // Reset redirect timeout
    if (this.redirectTimeout !== false) {
      clearTimeout(this.redirectTimeout);
      this.redirectTimeout = false;
    }

    // Reset variable and timeline
    this.killTimeline(this.currentTimeline);

    // const resetCallback = () => {
    //   // Things that reset after goToScreen
    //   // TODO: Reset things here
    // }

    // if (typeof screenId == "undefined") {
    //   resetCallback();
    // }

    // if (super.reset(screenId, resetCallback) === false) {
    //   return false;
    // }

    // Overwrite super
    this.closeStillThereModal();

    // Return to idle screen
    this.switchGame(0);
  }

}
